import { render, staticRenderFns } from "./CustomFieldEdit.vue?vue&type=template&id=4290fce6&scoped=true&"
import script from "./CustomFieldEdit.vue?vue&type=script&setup=true&lang=js&"
export * from "./CustomFieldEdit.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4290fce6",
  null
  
)

export default component.exports